var _path, _g, _path2, _path3, _circle, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopFrame = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 672 405.36",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3D3D3D",
  fillRule: "evenodd",
  d: "M17.115 0h637.77C664.34 0 672 7.66 672 17.115v370.77c0 9.455-7.66 17.115-17.115 17.115H17.115C7.66 405 0 397.34 0 387.885V17.115C0 7.66 7.66 0 17.115 0m-4.053 13.961c-.746 0-1.351.605-1.351 1.351v374.823c0 .746.605 1.351 1.351 1.351h645.877c.746 0 1.351-.605 1.351-1.351V15.312c0-.746-.605-1.351-1.351-1.351z",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#1F1F1F"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54.499,
  height: 4.054,
  x: 311.228,
  y: 4.953,
  rx: 2.027
}), /*#__PURE__*/React.createElement("circle", {
  cx: 371.807,
  cy: 6.98,
  r: 2.027
}), /*#__PURE__*/React.createElement("circle", {
  cx: 300.193,
  cy: 6.98,
  r: 2.027
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M13.062 13.961c-.746 0-1.351.605-1.351 1.351v16.665H660.29V15.312c0-.746-.605-1.351-1.351-1.351z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22.52 18.465h8.558v8.558H22.52z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 41.212,
  cy: 22.744,
  r: 4.279,
  fill: "#FFF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m54.499 18.465 4.955 8.558h-9.909z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 273.845,
  height: 9.909,
  x: 199.528,
  y: 18.016,
  fill: "#FFF",
  rx: 4.504
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  d: "M468.644 22.032a2.43 2.43 0 0 1-2.427 2.428 2.42 2.42 0 0 1-1.58-.587l-.101.104v.296l-1.867 1.864-.557-.557 1.864-1.867h.295l.105-.1a2.427 2.427 0 1 1 4.268-1.58m-.748 0c0-.93-.75-1.68-1.679-1.68-.93 0-1.681.75-1.681 1.68s.751 1.68 1.681 1.68c.929 0 1.679-.75 1.679-1.68"
})));
export default SvgDesktopFrame;